import * as React from 'react'
import { SVGProps } from 'react'
const SvgSearch2 = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="#1C1915" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11 2.5a8.5 8.5 0 1 0 5.646 14.854L21 21.707l.707-.707-4.353-4.354A8.5 8.5 0 0 0 11 2.5ZM3.5 11a7.5 7.5 0 1 1 15 0 7.5 7.5 0 0 1-15 0Z"
    />
  </svg>
)
export default SvgSearch2
